import ErrorHandler from 'store/utils/ErrorHandler';
import Notify from 'store/utils/Notify';

import * as api from './api';
import * as types from './actionTypes';

/**
 * Get Rule Entities
 *
 * @param params
 */

// eslint-disable-next-line import/prefer-default-export
export const getRuleEntitiesList = (params = {}) => async dispatch => {
  try {
    await dispatch({
      type: types.GET_RULE_ENTITIES_REQUEST,
    });

    const response = await api.getRuleEntitiesRequest(params);

    await dispatch({
      type: types.GET_RULE_ENTITIES_SUCCESS,
      payload: {
        list: response.data.results,
      },
    });
  } catch (error) {
    await dispatch({
      type: types.GET_RULE_ENTITIES_ERROR,
      payload: {
        error: error.message,
      },
    });

    Notify.error({
      title: 'An error occurred',
      description: ErrorHandler.getNotificationError(error),
    });
  }
};
